module.exports = __webpack_public_path__ + "static/img/IntelligentHealthOS.d11c6cae.png";